import { render, staticRenderFns } from "./AddTrunk.vue?vue&type=template&id=713bfa9c&"
import script from "./AddTrunk.vue?vue&type=script&lang=js&"
export * from "./AddTrunk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports